import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { UseSelectionStateType } from '../../../../../hooks/useSelectionState';
import { numberToFormattedCount } from '../../../../../models/UiUtils';
import { Button } from '../../../../components/Button';
import { ChevronRight } from '../../../../components/svgs/icons/ChevronRight';
import { TagIcon } from '../../../../components/svgs/icons/TagIcon';
import { baseStyleSheet } from '../../../../styles/styles';
import { useTagsDataContext } from '../TagsContexts/TagsDataContext';
import { useTagsSearchContext } from '../TagsContexts/TagsSearchContext';
import { styleSheet } from './styles';

interface TagsSearchDescriptionProps {
	selectionState: UseSelectionStateType;
}

export const TagsSearchDescription: React.FC<TagsSearchDescriptionProps> = observer(({ selectionState }) => {
	const { categories, tags, selectedCategory, setSelectedCategory } = useTagsDataContext();
	const { searchTerm } = useTagsSearchContext();

	const handleClearSelection = () => {
		setSelectedCategory(null);
		selectionState.reset();
	};

	if (selectedCategory) {
		return (
			<div className={css(styleSheet.container)}>
				<div className={css(styleSheet.categoryName)}>
					<TagIcon className={css(styleSheet.categoryIcon)} fillColor={selectedCategory.color} />
					<span className={css(styleSheet.categoryNameText)}>{selectedCategory.name}</span>
				</div>
				<Button kind='reverse' size='small' onClick={handleClearSelection}>
					<span className={css(styleSheet.backButton)}>
						<ChevronRight className={css(styleSheet.backIcon)} />
						<span className={css(styleSheet.backText)}>Back to full tag list</span>
					</span>
				</Button>
			</div>
		);
	}

	return (
		<div className={css(styleSheet.container)}>
			<span className={css(baseStyleSheet.fontBold)}>{numberToFormattedCount(tags?.totalCount ?? 0)}</span>
			&nbsp;
			{tags?.totalCount === 1 ? 'tag' : 'tags'}
			{!selectedCategory && (
				<>
					&nbsp; &amp; &nbsp;
					<span className={css(baseStyleSheet.fontBold)}>{numberToFormattedCount(categories?.totalCount ?? 0)}</span>
					&nbsp;
					{categories?.totalCount === 1 ? 'category' : 'categories'}
				</>
			)}
			{!!searchTerm && (
				<span>
					&nbsp;
					{'for "'}
					<span className={css(baseStyleSheet.fontBold)}>{searchTerm + '"'}</span>
				</span>
			)}
		</div>
	);
});
